(() => {
  const initialize = (eventsSlider) => {
    const element = eventsSlider.element;

    const slider = new Glide(element, {
      bound: true,
      focusAt: 'center',
      rewind: false,
      breakpoints: {
        // Up to 1024px
        1024: {
          gap: 20,
          perView: 2,
          peek: 40,
        },
        // Up to 768px
        768: {
          gap: 20,
          perView: 1,
          peek: 40,
        },
      },
      classes: {
        direction: {
          ltr: `${element.classList}--ltr`,
          rtl: `${element.classList}--rtl`,
        },
        slider: `${element.classList}--slider`,
        carousel: `${element.classList}--carousel`,
        swipeable: `${element.classList}--swipeable`,
        dragging: `${element.classList}--dragging`,
        cloneSlide: `${element.classList}__slide--clone`,
        activeNav: `${element.classList}__bullet--active`,
        activeSlide: `${element.classList}__slide--active`,
        disabledArrow: `${element.classList}__arrow--disabled`,
      },
    });

    function resizeWindow() {
      if (window.matchMedia('(min-width: 1000px)').matches) {
        slider.destroy();
      } else {
        slider.mount();
      }
    }

    resizeWindow();

    const delay = (() => {
      let timer = 0;
      return (callback, ms) => {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    })();

    window.onresize = () => {
      delay(() => {
        resizeWindow();
      }, 500);
    };
  };

  const eventsSlider = stp.setup('events-slider');

  eventsSlider.map(initialize);
})();
